import React from 'react';
import { Message } from 'semantic-ui-react';

export class UploadPricingDataForm extends React.Component {
    state = {
        isDragOver: false,
    };

    // create a ref for automatic smooth scrolling to the end of
    // the form in case of error/warning
    messagesEndRef = React.createRef();

    scrollToBottom = () => {
        this.messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    componentDidUpdate(prevProps) {
        // eslint-disable-next-line no-unused-expressions
        (this.props.formErrorNotification || this.props.formWarningNotification || this.props.formSuccessNotification)
            ? this.scrollToBottom() : null;
    }

    handleFileSelect = (e) => {
        const file = e.target.files[0];
        const maxSize = 10 * 1024 * 1024; // 10MB in bytes

        if (!file) return;

        if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            alert("Please select a valid XLSX file");
            e.target.value = null;
            return;
        }

        if (file.size > maxSize) {
            alert("File size exceeds 10MB limit. Please select a smaller file.");
            e.target.value = null;
            return;
        }

        this.props.onFileSelect(file);
    };

    handleDismiss = () => {
        this.props.onDismiss();
    };

    render() {
        const {
            formMessage,
            formMessageHeader,
            formWarningNotification,
            formErrorNotification,
            formSuccessNotification,
            selectedFile
        } = this.props;

        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "25px"
            }}>
                {/* Only show upload area and instructions if no success/warning message */}
                {!(formSuccessNotification || formWarningNotification) && (
                    <>
                        {/* Upload Area */}
                        <div style={{
                            width: "100%",
                            border: selectedFile
                                ? "2px solid #21ba45"
                                : "2px dashed #cccccc",
                            borderRadius: "12px",
                            padding: "40px 20px",
                            backgroundColor: selectedFile
                                ? "#f0fff0"
                                : "#fafafa",
                            textAlign: "center",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            position: "relative"
                        }}>
                            <input
                                type="file"
                                accept=".xlsx"
                                onChange={this.handleFileSelect}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    opacity: 0,
                                    cursor: "pointer"
                                }}
                            />

                            {selectedFile ? (
                                <div>
                                    <i className="file excel outline icon"
                                       style={{ fontSize: "50px", color: "#21ba45" }} />
                                    <h4 style={{ color: "#333", margin: "15px 0 5px 0" }}>
                                        File Selected
                                    </h4>
                                    <div style={{
                                        backgroundColor: "white",
                                        padding: "15px",
                                        borderRadius: "8px",
                                        border: "1px solid #e0e0e0",
                                        marginTop: "15px"
                                    }}>
                                        <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                                            {selectedFile.name}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#666" }}>
                                            {(selectedFile.size / 1024).toFixed(2)} KB
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <i className="cloud upload icon"
                                       style={{ fontSize: "50px", color: "#cccccc" }} />
                                    <h4 style={{ color: "#333", margin: "15px 0 5px 0" }}>
                                        Choose Excel File
                                    </h4>
                                    <p style={{ color: "#999", margin: "0", fontSize: "14px" }}>
                                        Click here or drag and drop your XLSX file
                                    </p>
                                </div>
                            )}
                        </div>

                        {/* Instructions */}
                        <div style={{
                            width: "100%",
                            backgroundColor: "#fff3cd",
                            border: "1px solid #ffeaa7",
                            borderRadius: "8px",
                            padding: "15px"
                        }}>
                            <div style={{ display: "flex", alignItems: "flex-start" }}>
                                <i className="info circle icon"
                                   style={{ color: "#856404", marginRight: "10px", marginTop: "2px" }} />
                                <div>
                                    <strong style={{ color: "#856404" }}>File Requirements:</strong>
                                    <ul style={{
                                        margin: "5px 0 0 0",
                                        paddingLeft: "20px",
                                        color: "#856404",
                                        fontSize: "13px"
                                    }}>
                                        <li>File must be in .xlsx format</li>
                                        <li>Maximum file size: 10MB</li>
                                        <li>Use the provided template to ensure the data gets processed correctly</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Add message display before the ref */}
                {(formSuccessNotification || formErrorNotification || formWarningNotification) && (
                    <div style={{ width: "100%" }}>
                        <Message
                            error={formErrorNotification}
                            warning={formWarningNotification}
                            success={formSuccessNotification}
                            header={formMessageHeader}
                            list={formMessage}
                            visible={true}
                            onDismiss={this.handleDismiss}
                        />
                    </div>
                )}

                <div ref={this.messagesEndRef}/>
            </div>
        );
    }
}

export default UploadPricingDataForm;
